import emit from '@fishx/emit';
import { cookieUtils } from '@fishx/utils';

const { getCookie, setCookie } = cookieUtils;
import { CHANGE_FISHX_LANGUAGE } from './index';

interface LangMap {
  [name: string]: string;
}

const LangMap: LangMap = {
  zh: 'zh-CN',
  en: 'en-US',
  es: 'es-ES',
  id: 'id-ID',
};

export default function setLang(locale: string, denyRefresh?: boolean) {
  const [country = '', lang = ''] = locale.split('-');
  if (lang === '') {
    locale = LangMap[country];
  }
  emit.emit(CHANGE_FISHX_LANGUAGE, locale);
  if (typeof window !== 'undefined') {
    const localLocale = window.localStorage.getItem('fishx_locale');
    if (localLocale !== locale) {
      window.localStorage.setItem('fishx_locale', locale || '');
      if (getCookie('userLocale')) {
        setCookie('userLocale', locale, 'd30');
      } else if(getCookie('areaLocale')) {
        setCookie('areaLocale', locale, 'd30');
      } else if (getCookie('ZSMART_LOCALE')) {
        setCookie('ZSMART_LOCALE', locale, 'd30');
      }
      if (!denyRefresh) {
        window.location.reload();
      }
    }
  }
}
